export interface AppliedRate {
  amount: number;
  rate: number;
}

export const appliedRateFromResponse = (responseData: any): AppliedRate => ({
  amount: responseData.amount,
  rate: responseData.rate,
});
